import React from 'react';
import { Button, Icon, Label, Item, Header } from 'semantic-ui-react';
import { ButtonContainer } from './styles';
import { SegmentContainer } from '../../global.styles';

const ItemSegment = ({
  rentalItem,
  handleRedirectToForm,
  openModal,
  isOwner,
  handleAddItem,
  handleWishlistItem,
  isRentalInWishlist, 
  handleContactOwner
}) => {
  return (
    <SegmentContainer>
      {rentalItem?.status === 'rented' && (
        <Label attached='top left' tag color='green' size='tiny'>
          Rented
        </Label>
      )}
      {rentalItem?.status === 'inactive' && (
        <Label attached='top left' tag color='black' size='tiny'>
          Inactive
        </Label>
      )}
      <Item.Group>
        <Item>
          <Item.Image
            size='small'
            src={rentalItem?.image || '/images/fallback.png'}
          />
          <Item.Content>
            <Header>
              <h3> {rentalItem?.name}</h3>
            </Header>
            <Item.Description>
              <p>{rentalItem?.description}</p>
            </Item.Description>
            <Item.Extra>
                <ButtonContainer> 
              {isOwner ? (
                <>
                  <Button positive content='Edit' onClick={handleRedirectToForm} />
                  <Button content='Delete' onClick={openModal} />
                </>
              ) : (
                <>
                  <Button icon labelPosition='right' onClick={handleAddItem}>
                    <Icon name='cart' />
                    Rent
                  </Button>
                  <Button positive icon labelPosition='right' onClick={handleContactOwner}>
                    <Icon name='mail' />
                    Contact 
                  </Button>
                  <Button color='teal' icon labelPosition='right' onClick={handleWishlistItem}>
                    <Icon name='heart' />
                    {isRentalInWishlist ? 'Added' : 'Wishlist'}
                  </Button>
                </>
              )}
              </ButtonContainer>
            </Item.Extra>
          </Item.Content>
        </Item>
      </Item.Group>
    </SegmentContainer>
  );
};

export default ItemSegment;
